interface IProps {
  margin: number;
}
export default function Spacer(props: IProps) {
  return <span style={{ margin: props.margin }}></span>;
}
